module.exports = __webpack_public_path__ + "assets/img/155d-si.svg";